export default __webpack_public_path__ + "static/media/home-publicar-mobile.aa033db2.jpg";